import { OptionsAndLinksService } from './providers/options-and-links.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage/';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  pages: Observable<any>; //pages with metadata
  stepperPos = []; //stepper position + eventual text 
  selected = 1; //currently selected page
  selectedOptions = []; //list with added features -- this is the shopping cart atm
  list = []; //momentarily used for adding features to basket
  selectedImage: String;
  openPanels = [];
  engravingForm: FormGroup;
  field_a = "";
  field_b = "";
  priceLabel: number = 0;
  selectedEngravingOptie = false;
  opties = [
    { text: "Yes, Add an Engraving", value: true },
    { text: "No, I'm Good", value: false }
  ];

  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer,
    private db: AngularFirestore, private storage: AngularFireStorage,
    public service: OptionsAndLinksService) {
    iconRegistry.addSvgIcon(
      'chevron-down',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/chevron_down.svg")
    );

    iconRegistry.addSvgIcon(
      'chevron-left',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/chevron_left.svg")
    )

    iconRegistry.addSvgIcon(
      'chevron-up',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/chevron_up.svg")
    )

    iconRegistry.addSvgIcon(
      'chevron-right',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/chevron_right.svg")
    )

    iconRegistry.addSvgIcon(
      'cancel',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/cancel_circle.svg")
    )

    iconRegistry.addSvgIcon(
      'ok',
      sanitizer.bypassSecurityTrustResourceUrl("../assets/ok.svg")
    )
  }


  getValue(engravingOptie: any){
    if (!this.selectedEngravingOptie){
      this.removeFromList(engravingOptie);
    }
  }

  ngOnInit(): void {
    //get all pages
    this.pages = this.db.collection('generationsrallywatch', ref => ref.orderBy('position')).valueChanges();
    this.pages.subscribe(data => {
      //set mainImage
      this.selectedImage = data[this.selected - 1].mainImage;
      //set stepper
      this.stepperPos = [];
      for (let x in data) {
        let obj = { position: data[x].position, title: data[x].stepperTitle };
        this.stepperPos.push(obj);
      }
    });

    this.mainImageController();
    this.priceLabel = this.service.totalPrice;

    this.engravingForm = new FormGroup({
      a_field: new FormControl("", [Validators.maxLength(12), Validators.pattern('^[a-z A-Z 0-9.-]+$')]),
      b_field: new FormControl("", [Validators.maxLength(12), Validators.pattern('^[a-z A-Z 0-9.-]+$')]),
      email: new FormControl("", [Validators.required, Validators.email, Validators.minLength(4)])
    });
  }

  chevronSwitcher(index: any) {
    let list = [];

    if (this.panelChecker(index) == true) {
      for (let y of this.openPanels) {
        console.log(y);
        console.log(index);
        if (y != index) {
          list.push(y);
        }
      }
      this.openPanels = list;
    } else {
      this.openPanels.push(index);
      console.log(this.openPanels);
    }
  }

  removeFromList(option: any) {
    this.service.removeFromCart(option);
  }

  panelChecker(index: any) {
    let number = 0;
    for (let x of this.openPanels) {
      if (x == index) {
        number = number + 1;
      }
    }

    if (number > 0) {
      return true;
    } else {
      return false;
    }
  }

  formChecker() {
    if (this.engravingForm.invalid || this.engravingForm.controls.a_field.value.length < 1 && this.engravingForm.controls.b_field.value.length < 1) {
      return true;
    }
    else {
      return false;
    }
  }

  addEngraving(option: any) {
    if (this.engravingForm.valid) {
      if (this.engravingForm.controls.a_field.value.length < 1 &&
        this.engravingForm.controls.b_field.value.length < 1) {
        console.log("velden mogen niet leeg zijn");
      } else {
        this.service.addToCart(option, this.selected);
        this.selectedImage = option.optionBigImage;
      }
    }
    else {
      console.log("invalid!");
    }
  }

  voegToeAanLijst(option: any) {
    this.service.addToCart(option, this.selected);
    // this.service.addToOptionList(option);
    this.selectedImage = option.optionBigImage;
  }

  goBack() {
    console.log("went back lolz");
    if (this.selected > 1) {
      this.selected = this.selected - 1;
      this.mainImageController();
      window.scrollTo(0, 0)
    }
  }

  mainImageController() {
    this.pages.subscribe(data => {
      if (data[this.selected - 1].isEngravingPage == false) {
        if (data[this.selected - 1].mainImage == null) {
          for (let x of data[this.selected - 1].features) {
            if (x.isMainOption) {
              if (!this.service.hasBeenThere(this.selected)) {
                this.service.addToCart(x, this.selected);
              }
              this.selectedImage = x.optionBigImage;
            }
          }
        } else {
          for (let x of data[this.selected - 1].features) {
            if (x.isMainOption) {
              if (!this.service.hasBeenThere(this.selected)) {
                this.service.addToCart(x, this.selected);
              }
              this.selectedImage = data[this.selected - 1].mainImage;
            }
          }
        }
      } else {
        this.selectedImage = data[this.selected - 1].mainImage;
      }
    });
  }

  nextPage() {
    console.log("next");
    if (this.selected < (this.stepperPos.length)) {
      this.selected = this.selected + 1;
      this.mainImageController();
      window.scrollTo(0, 0)
    } else {
      this.service.checkout(
        this.engravingForm.controls.a_field.value, 
        this.engravingForm.controls.b_field.value, 
        this.engravingForm.controls.email.value
        );
    }
  }
}
